// extracted by mini-css-extract-plugin
export default {"imageWrapper":"rK-z","twoColumnImage":"sK-z"};